<div class="register-container">
  <div class="register-box">
    <h2 class="title">{{ translationService.getTranslation('registro') }}</h2>
    
    <form (ngSubmit)="register()">
      <!-- Campo de Nombre de Usuario -->
      <label for="username">{{ translationService.getTranslation('NombredeUsuario') }}</label>
      <input id="username" type="text" [(ngModel)]="username" name="username" placeholder="Username" required>

      <!-- Campo de Email -->
      <label for="email">{{ translationService.getTranslation('mail') }}</label>
      <input id="email" type="email" [(ngModel)]="email" name="email" placeholder="example@example.com" required>

      <!-- Campo de Contraseña -->
      <label for="password">{{ translationService.getTranslation('Contrasena') }}</label>
      <div class="password-container">
        <input id="password" [type]="showPassword ? 'text' : 'password'" [(ngModel)]="password" name="password" placeholder="password" required>
        <button type="button" class="toggle-password" (click)="togglePasswordVisibility()" aria-label="Toggle password visibility">
          <i [class]="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
        </button>
      </div>

      <!-- Campo de Nacionalidad -->
      <label for="nationality">{{ translationService.getTranslation('Nacionalidad') }}</label>
      <select id="nacionalidad" [(ngModel)]="nacionalidad" name="nacionalidad" required>
        <option *ngFor="let country of countries" [value]="country.code">
          {{ country.name }}
        </option>
      </select>

      <!-- Botón de Registro -->
      <button type="submit" [disabled]="isLoading">
        <span *ngIf="!isLoading">{{ translationService.getTranslation('registro') }}</span>
        <span *ngIf="isLoading" class="loader"></span>
      </button>
    </form>

    <p *ngIf="errorMessage" class="error-message">{{ errorMessage }}</p>

    <div class="login-link">
      <p>{{ translationService.getTranslation('yacuenta') }} <a href="/login">{{ translationService.getTranslation('login') }}</a></p>
    </div>
  </div>
</div>

<style>
/* Contenedor del campo de contraseña */
.password-container {
    position: relative;
    display: flex;
    align-items: center;
}

.password-container input {
    flex: 1;
    padding-right: 40px; /* Espacio para el botón del ojo */
}

.toggle-password {
    position: absolute;
    right: 10px; /* Alinea el botón a la derecha */
    top: 50%; /* Centra verticalmente el botón */
    transform: translateY(-50%); /* Ajusta el centrado vertical */
    background: none;
    border: none;
    cursor: pointer;
    outline: none;
    color: white;
    font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0; /* Elimina cualquier padding adicional */
    height: auto; /* Ajusta la altura al contenido */
    width: auto; /* Ajusta el ancho al contenido */
}

.toggle-password i {
    pointer-events: none; /* Evita que el ícono interfiera con el clic */
}
</style>


